<template>
  <div>
    <HeadBanner
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.HeadBanner.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.HeadBanner.data')
      "
    />
    <Breadcrumb />

    <div class="news-head mt-55">
      <NewsMediaFilter
        v-if="
          _.get(
            this.$store.state.current_content,
            'secondary.NewsMediaFilter.conf.enabled'
          ) == 1
        "
        :itemData="
          _.get(
            this.$store.state.current_content,
            'secondary.NewsMediaFilter.data'
          )
        "
      />
    </div>

    <section class="container news-section bg-white">
      <div class="news-main-boxes flex-box between">
        <article class="article-left">
          <a href="#">
            <div class="img-box">
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcset="@/assets/img/img(40).jpg"
                />
                <source
                  media="(max-width: 1023px)"
                  srcset="@/assets/img/img(40).jpg"
                />
                <img src="@/assets/img/img(40).jpg" class="img-absolute" alt />
              </picture>
              <div class="gradient"></div>
              <div class="img-overlay"></div>
              <div class="date mob btn-20 bg-white">
                <span>15 Apr. 2020</span>
              </div>
            </div>
            <div class="article-left-content">
              <div class="date btn-20 bg-white"><span>15 Apr. 2020</span></div>
              <h1 class="other-title white">
                Black Sea Trade and Development Bank extends additional credit
                facility to Basisbank
              </h1>
              <div class="btn sub">Read more</div>
            </div>
          </a>
        </article>
        <article class="article-right">
          <a href="#" class="flex-box column">
            <div class="img-box">
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcset="@/assets/img/1.jpg"
                />
                <source
                  media="(max-width: 1023px)"
                  srcset="@/assets/img/1.jpg"
                />
                <img src="@/assets/img/1.jpg" class="img-absolute" alt />
              </picture>
              <div class="img-overlay"></div>
              <div class="date-box btn-20 bg-white">
                <span>15 Apr. 2020</span>
              </div>
            </div>
            <div class="news-text-box bg-white flex-box column">
              <h2 class="news-title">BasisBank service centers working</h2>
              <div class="text mt-21">
                Dear Customers! Please note that 17, 18, 19 and 20 of April are
                holidays. We appreciate that you use our service! Dear
                Customers! Please note that 17, 18, 19 and 20 of April are
                holidays. We appreciate that you use our service! Dear
                Customers! Please note that 17, 18, 19 and 20 of April are
                holidays. We appreciate that you use our service! Dear
                Customers! Please note that 17, 18, 19 and 20 of April are
                holidays. We appreciate that you use our service!
              </div>
              <div class="read-btn blue font-12 noto-semibold">
                keep reading
              </div>
            </div>
          </a>
        </article>
      </div>
    </section>

    <section class="container">
      <div class="news-container flex-box wrap">
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(33).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(33).jpg"
              />
              <img src="@/assets/img/img(33).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">BasisBank service centers working</h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(30).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(30).jpg"
              />
              <img src="@/assets/img/img(30).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">
              BasisBank service centers working BasisBank service centers
              working
            </h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(42).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(42).jpg"
              />
              <img src="@/assets/img/img(42).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <img src="@/assets/img/play-btn.svg" alt class="play-btn" />
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">BasisBank service centers working</h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(29).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(29).jpg"
              />
              <img src="@/assets/img/img(29).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">BasisBank service centers working</h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(40).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(40).jpg"
              />
              <img src="@/assets/img/img(40).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">BasisBank service centers working</h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
        <a href="#" class="news-item flex-box column">
          <div class="img-box">
            <picture>
              <source
                media="(max-width: 767px)"
                srcset="@/assets/img/img(17).jpg"
              />
              <source
                media="(max-width: 1023px)"
                srcset="@/assets/img/img(17).jpg"
              />
              <img src="@/assets/img/img(17).jpg" class="img-absolute" alt />
            </picture>
            <div class="img-overlay"></div>
            <div class="date-box btn-20 bg-white">
              <span>15 Apr. 2020</span>
            </div>
          </div>
          <div class="news-text-box flex-box column">
            <h3 class="news-title">BasisBank service centers working</h3>
            <div class="read-btn blue font-12 noto-semibold">keep reading</div>
          </div>
        </a>
      </div>
    </section>

    <div class="news-pagination">
      <Pagination />
    </div>
  </div>
</template>

<script>
import HeadBanner from "@/components/HeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import NewsMediaFilter from "@/components/NewsMediaFilter";
import Pagination from "@/components/Pagination";

export default {
  components: {
    HeadBanner,
    Breadcrumb,
    Pagination,
    NewsMediaFilter,
  },
};
</script>